// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__cBBbT","gifContainer":"Cards_gifContainer__rAd+8","gifAnimation":"Cards_gifAnimation__XS5cJ"};